import { render, staticRenderFns } from "./PartForm.vue?vue&type=template&id=53626228"
import script from "./PartForm.vue?vue&type=script&lang=ts"
export * from "./PartForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports